<template>
	<div
		:class="[
			'text-center grid place-items-center rounded-full border p-3',
			props.type === 'active'
				? 'text-primary border-primary-light bg-primary-light'
				: 'text-gray-darker border-gray bg-gray'
		]"
	>
		<component
			:is="icon"
			:class="[props.size === 'md' ? 'size-6' : 'size-4']"
		></component>
	</div>
</template>

<script setup lang="ts">
import type { Props } from '@/types/ChannelIcon'
import Person from '@/assets/icons/person.svg'
import EmptyBox from '@/assets/icons/empty-box.svg'
import { computed } from 'vue'

const props = withDefaults(defineProps<Props>(), {
	type: 'active',
	size: 'md'
})

/**
 * returns detail based by chat type
 */
const icon = computed(() => {
	if (props.type === 'active') {
		return Person
	}

	return EmptyBox
})
</script>

<style scoped></style>
